"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.fnv1a = exports.adler32 = void 0;
exports.phash = phash;
var adler32 = exports.adler32 = function enclose() {
  var OPTIMUS_PRIME = 65521; // more than meets the eye.

  /**
   * Implementation of the (fast) non-cryptographic hash adler32, this
   * version is optimised for JS strings. It was lifted from React's source, see
   * `https://github.com/facebook/react/blob/master/src/shared/utils/adler32.js`.
   * They themselves lifted it from SheetJS, see `https://github.com/SheetJS/js-adler32`
   *
   * @param {String} str - The string to be hashed.
   *
   * @returns {Number} hash - The generated hash.
   */
  return function _adler32(str) {
    var a = 1;
    var b = 0;
    var i = 0;
    var l = str.length;
    var m = l & ~0x3;
    while (i < m) {
      var n = Math.min(i + 4096, m);
      for (; i < n; i += 4) {
        b += (a += str.charCodeAt(i)) + (a += str.charCodeAt(i + 1)) + (a += str.charCodeAt(i + 2)) + (a += str.charCodeAt(i + 3));
      }
      a %= OPTIMUS_PRIME;
      b %= OPTIMUS_PRIME;
    }
    for (; i < l; i++) {
      // eslint-disable-next-line no-multi-assign
      b += a += str.charCodeAt(i);
    }
    a %= OPTIMUS_PRIME;
    b %= OPTIMUS_PRIME;
    return a | b << 16;
  };
}();
var fnv1a = exports.fnv1a = function enclose() {
  var PRIME = 0x811c9dc5;

  /**
   * This is an implementation of the fast (non-crypto) fnv-1a hash - it is
   * optimised for a low likelyhood of collisions.
   *
   * SEE: `https://gist.github.com/vaiorabbit/5657561` for reference implementation.
   * SEE: `http://isthe.com/chongo/tech/comp/fnv/` for some documentation.
   *
   * @param {String} str - The string to be hashed.
   *
   * @returns {Number} hash - The generated hash.
   */
  return function _fnv1a(str) {
    var hash = PRIME;
    for (var i = 0; i < str.length; ++i) {
      hash ^= str.charCodeAt(i);
      hash += (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
    }
    return hash >>> 0;
  };
}();

/**
 * adler32 returns a signed integer, which generally looks ugly in (for
 * instance) a URL. phash (pretty hash) just wraps adler32 to produce an
 * unsigned hex representation of the same integer.
 *
 * @param {String} str - The string to be hashed.
 *
 * @returns {String} hash - A prettyfied (sort of) adler32 hash.
 */
function phash(str) {
  return Math.abs(fnv1a(str)).toString(16);
}